import styles from "./SkillItem.module.css";
import {
  SiSpring,
  SiHibernate,
  SiMysql,
  SiHtml5,
  SiCss3,
  SiApachemaven,
  SiSpringboot,
  SiReact,
  SiJavascript,
  SiIcon,
  SiFlutter,
  SiGit,
  SiApachekafka,
  SiDocker,
} from "react-icons/si";

import { FaJava } from "react-icons/fa";

const SkillItem = (props) => {
  let component = null;
  let label = null;
  switch (props.name) {
    case "spring":
      component = <SiSpring />;
      label = "Spring Core";
      break;
    case "hibernate":
      component = <SiHibernate />;
      label = "Hibernate";
      break;
    case "mysql":
      component = <SiMysql />;
      label = "MySql";
      break;
    case "java":
      component = <FaJava />;
      label = "Java SE 8";
      break;
    case "html":
      component = <SiHtml5 />;
      label = "HTML 5";
      break;
    case "css":
      component = <SiCss3 />;
      label = "CSS 3";
      break;
    case "maven":
      component = <SiApachemaven />;
      label = "Maven";
      break;
    case "boot":
      component = <SiSpringboot />;
      label = "Spring Boot";
      break;
    case "react":
      component = <SiReact />;
      label = "React JS";
      break;
    case "kafka":
      component = <SiApachekafka />;
      label = "Kafka";
      break;

    case "docker":
      component = <SiDocker />;
      label = "Docker";
      break;

    case "js":
      component = <SiJavascript />;
      label = "JS ES6";
      break;
    case "flutter":
      component = <SiFlutter />;
      label = "Flutter";
      break;
    case "git":
      component = <SiGit />;
      label = "Git";
      break;
    default:
      component = <SiIcon />;
      label = "Loading";
      break;
  }
  return (
    <div
      className={`p-4 mx-2 w-24 md:w-60 flex flex-col justify-evenly items-center ${styles.wrapper} bg-white `}
    >
      <div className={styles.skill}>{component}</div>
      <div className={styles.label}>{label}</div>
    </div>
  );
};

export default SkillItem;
